import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth';

export const RequireRole = ({ roles, children, loginPath = '/login' }) => {
  const { user } = useAuthStore();
  if (!user) return <Navigate to={loginPath} replace />;
  if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
